import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Download } from 'lucide-react';
import { menuData } from '../data/menuData';

const MenuSection = () => {
  return (
    <section id="menu" className="py-20 bg-zinc-950 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-red-500 text-sm font-semibold tracking-widest uppercase mb-4">
            Tutustu laajaan valikoimaamme
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Ruokalistamme
          </h2>
        </div>

        <Tabs defaultValue="pizzat" className="w-full max-w-7xl mx-auto">
          <TabsList className="flex flex-wrap justify-center gap-2 bg-transparent mb-8 h-auto">
            {menuData.map((category, index) => (
              <TabsTrigger
                key={category.id}
                value={category.id}
                className="bg-zinc-900 border border-zinc-800 text-white data-[state=active]:bg-red-600 data-[state=active]:text-white hover:bg-zinc-800 transition-all duration-300 px-4 py-2"
              >
                <span className="text-red-500 font-bold mr-2 data-[state=active]:text-white">
                  {String(index + 1).padStart(2, '0')}
                </span>
                {category.name}
              </TabsTrigger>
            ))}
          </TabsList>

          {menuData.map((category) => (
            <TabsContent key={category.id} value={category.id} className="mt-8">
              {category.description && (
                <p className="text-center text-white/70 mb-6 text-lg">
                  {category.description}
                </p>
              )}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.items.map((item, index) => (
                  <div
                    key={index}
                    className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 hover:border-red-600 transition-all duration-300 hover:scale-105"
                  >
                    <h3 className="text-xl font-bold mb-2 text-white">{item.name}</h3>
                    {item.description && (
                      <p className="text-white/60 text-sm mb-4 leading-relaxed">{item.description}</p>
                    )}
                    <div className="text-red-500 font-bold text-lg mt-auto">{item.price}</div>
                  </div>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>

        <div className="text-center mt-12">
          <button
            disabled
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Download size={20} />
            Lataa ruokalista (PDF)
          </button>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
